import { Component } from '@angular/core';
import { ManagementService } from '../../services/management.service';

@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrl: './areas.component.scss',
})
export class AreasComponent {
  searchTerm = '';
  showRegisterModal: boolean = false;
  showEditModal: boolean = false;
  showRegisterJobPositionModal: boolean = false;
  showEditJobPositionModal: boolean = false;
  isLoading: boolean = true;
  selectedAreaId: number | null = null;
  selectedJobPositionId: number | null = null;
  searchTimeout: any;

  jobAreaData: any[] = [];

  constructor(private managementService: ManagementService) {}

  ngOnInit(): void {
    this.filterData();
  }

  filterData(): void {
    this.isLoading = true;

    const filters = {
      search: this.searchTerm,
    };

    this.managementService.postListAreas(filters).subscribe({
      next: (data: any[]) => {
        this.jobAreaData = data;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error al obtener los datos:', err);
      },
    });
  }

  onDialogClose() {
    this.showRegisterModal = false;
    this.showEditModal = false;
    this.selectedAreaId = null;
  }

  onDialogJobPositionClose() {
    this.showRegisterJobPositionModal = false;
    this.showEditJobPositionModal = false;
    this.selectedAreaId = null;
    this.selectedJobPositionId = null;
  }

  onSearch(query: string): void {
    this.searchTerm = query;

    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      if (this.searchTerm.length >= 3 || this.searchTerm.length === 0) {
        this.filterData();
      }
    }, 300);
  }

  onRegisterComplete(): void {
    this.filterData();
  }

  onEditComplete(): void {
    this.filterData();
  }

  onRegisterJobPositionComplete(): void {
    this.filterData();
  }

  onEditJobPositionComplete(): void {
    this.filterData();
  }

  onNewRegister(): void {
    this.showRegisterModal = true;
  }

  onNewRegisterJobPosition(areaItem: any): void {
    if (!areaItem?.areaId) {
      console.error('El item no contiene areaId', areaItem);
      return;
    }

    this.selectedAreaId = areaItem.areaId;
    this.showRegisterJobPositionModal = true;
  }

  onEditArea(areaItem: any): void {
    if (!areaItem?.areaId) {
      console.error('El item no contiene areaId', areaItem);
      return;
    }

    this.selectedAreaId = areaItem.areaId;
    this.showEditModal = true;
  }

  onEditJobPosition(areaItem: any): void {
    if (!areaItem?.item) {
      console.error('El item no contiene areaId', areaItem);
      return;
    }

    this.selectedAreaId = areaItem.item.areaId;
    this.selectedJobPositionId = areaItem.subitem.jobPositionId;
    this.showEditJobPositionModal = true;
  }
}
